enum ThSorts {
  NONE = 'none',
  ASC = 'asc',
  DESC = 'desc',
}

export {
  ThSorts,
};
